import { render, staticRenderFns } from "./PoiBit.vue?vue&type=template&id=523567dc&"
import script from "./PoiBit.vue?vue&type=script&lang=js&"
export * from "./PoiBit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports